export default {
  form: {
    name: 'Name',
    placeholder: 'Enter',
    nameEmptyWarning: 'Name cannot be empty.',
  },
}
